import React, { useEffect, useState } from "react";
import quizStyle from "./quiz.module.css";
import courseVideo from "./videos.module.css";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { useDispatch, useSelector } from "react-redux";
import { getSubmittedQuizScore } from "../redux/courseSlice";
import { CircularProgress } from "@mui/material";

const Quiz = ({ isCompleted, initialQuizData, courseType,courseId }) => {
  console.log("initialQuizData=========", initialQuizData);

  const dispatch = useDispatch();
  const { submittedQuizScoreData, isLoading } = useSelector(
    (state) => state.courses
  );
  console.log("submittedQuizScoreData", submittedQuizScoreData);
  const quizData =
    submittedQuizScoreData.length > 0
      ? submittedQuizScoreData[0]?.quizId
      : initialQuizData;
  console.log("quizData!!!!!!!", quizData);

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [quizStart, setQuizStart] = useState(false);
  const [isReSubmit, setIsResubmit] = useState(false);
  const [progress, setProgress] = useState(0);
  const [quizCompleted, setQuizCompleted] = useState(false); // Track if the quiz is complete
  const [selectedAnswers, setSelectedAnswers] = useState("");

  useEffect(() => {
    let data = `?courseId=${courseId}`;
    dispatch(getSubmittedQuizScore(data));
  }, [dispatch, initialQuizData]);

  const toggleQuizStart = () => {
    setQuizStart(!quizStart);
  };

  const [startProgress, setStartProgress] = useState(false); // Track if the progress bar should start

  const handleAnswerOptionClick = (questionId, selectedOption) => {
    // console.log("Question ID:", questionId); // Log the question ID
    // console.log("Selected Answer:", selectedOption); // Log the selected answer
    if (!startProgress) {
      setStartProgress(true);
      // console.log("Progress started");
    }

    const nextQuestion = currentQuestion + 1;
    setProgress((prev) => {
      // console.log("Progress updated:", prev + 1);
      return prev + 1;
    });

    // Store the selected answer
    setSelectedAnswers((prev) => {
      const updatedAnswers = [...prev];
      updatedAnswers[currentQuestion] = {
        questionId: questionId,
        answer: selectedOption,
      };
      return updatedAnswers;
    });

    if (nextQuestion < quizData?.questions?.length) {
      setCurrentQuestion(nextQuestion);
      // console.log("Next question:", nextQuestion);
    }
  };

  const isQuizReadyToSubmit =
    selectedAnswers.length === quizData?.questions?.length;

  const handleSubmitQuiz = async () => {
    try {
      const datas = {
        quizId: quizData?._id,
        submittedAnswers: selectedAnswers,
      };
      let id = `?courseId=${quizData?.courseId}`;
      const { data, status } = await api.submitQuiz(datas);
      console.log("data=================", data);

      if (status === 200) {
        Toastify.success("All Answers Submitted Successfully");
        dispatch(getSubmittedQuizScore(id));
        setQuizCompleted(true); // Display the success screen
        setIsResubmit(false)
      } else {
        Toastify.error("You have already submitted this quiz");
      }
    } catch (error) {
      console.error("Error fetching course count", error);
    }
  };

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: "grid",
            placeItems: "center",
            height: "50vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div
          className={courseVideo.courseCertification}
          style={{ marginTop: 20 }}
        >
          {submittedQuizScoreData?.length > 0 ? (
            <div>
                <div className={quizStyle.successMessage}>
                {!isReSubmit && (
                    <>
                    <div className={quizStyle.gradeStyle}>{/* <p>A1</p> */}</div>
                    <p className={quizStyle.description}>
                      {submittedQuizScoreData[0]?.quizId?.title}
                    </p>
                    <h3>Result</h3>
                    <h2>
                      Your Score : {submittedQuizScoreData[0]?.score || "0"} %
                    </h2>
                    <img src="/successQuiz.png" />
                    {submittedQuizScoreData[0]?.numOfAttempt < 3 && (
                      <>
                        <p style={{ color: "#0C0C0C" }}>
                          You can make{" "}
                          <strong>
                            {" "}
                            {3 - submittedQuizScoreData[0]?.numOfAttempt}
                          </strong>{" "}
                          more attempts for this quiz
                        </p>
                        <button
                          className={quizStyle.submitAnswerButton}
                          // onClick={isQuizReadyToSubmit ? handleSubmitQuiz : null}
                          // disabled={!isQuizReadyToSubmit}
                          onClick={() => {
                            console.log("Re-Submit button clicked");
                            console.log(
                              "Current Question State Before Reset:",
                              currentQuestion
                            );
                            console.log(
                              "Selected Answers Before Reset:",
                              selectedAnswers
                            );
                            console.log("Progress Before Reset:", progress);
    
                            setIsResubmit(true);
                            setQuizCompleted(false);
                            setCurrentQuestion(0);
                            setSelectedAnswers("");
                            setProgress(0);
    
                            console.log("Quiz Reset States");
                          }}
                        >
                          Re-Submit Quiz
                        </button>
    
    
                        
    
    
    
                      </>
                    )}
    
    </>

                )} 
              


              {isReSubmit && (
      <div>
        <div className={quizStyle.progressBarContainer}>
          {quizData?.questions?.map((_, index) => (
            <div
              key={index}
              className={`${quizStyle.progressSegment} ${
                startProgress && index < progress
                  ? quizStyle.active
                  : ""
              }`}
            ></div>
          ))}
        </div>
        <div className={quizStyle.questionSection}>
          <p className={quizStyle.questionNumber}>
            {currentQuestion + 1}.
          </p>
          <p className={quizStyle.questionText}>
            {quizData?.questions[currentQuestion]?.question}
          </p>
        </div>
        <div className={quizStyle.answerSection}>
          {quizData?.questions[currentQuestion]?.options?.map((option, index) => (
            <button
              key={index}
              className={`${quizStyle.answerButton} ${
                selectedAnswers[currentQuestion]?.answer === option
                  ? quizStyle.selectedAnswer
                  : ""
              }`}
              onClick={() =>
                handleAnswerOptionClick(
                  quizData?.questions[currentQuestion]?._id,
                  option
                )
              }
            >
              <div className={quizStyle.optionLabel}>
                {String.fromCharCode(65 + index)}
              </div>
              <div className={quizStyle.optionText}>
                {option}
              </div>
            </button>
          ))}
        </div>
        <div style={{display:"flex",justifyContent:"flex-end"}}>
        <button
          className={`${quizStyle.submitAnswerButton} ${
            isQuizReadyToSubmit
              ? quizStyle.activeButton
              : quizStyle.disabledButton
          }`}
          onClick={isQuizReadyToSubmit ? handleSubmitQuiz : null}
          disabled={!isQuizReadyToSubmit}
        >
        {isQuizReadyToSubmit ?  `Submit Quiz` : `Next` }   
        </button>

</div>
      
      </div>
    )}

        </div>

            </div>
          ) : (
            <div>
              { ((isCompleted?.length === 0 ||
              quizData?.length > 0 ||
              courseType === `LIVESTREAM`) && quizData !== null )  ? (
                <div>
                  <div className={courseVideo.authorName}>Quiz questions</div>
                  <div className={courseVideo.titletext}>{quizData?.title}</div>
                  <div className={courseVideo.descriptionText}>
                    {quizData?.subTitle}
                  </div>
                  {!quizStart && (
                    <div
                      className={courseVideo.quizStartStyle}
                      onClick={toggleQuizStart}
                    >
                      <img src="/document.png" alt="Start Icon" />
                      <span>Start now</span>
                    </div>
                  )}
                  {quizStart && (
                    <div>
                      {quizCompleted ? (
                        // Success UI
                        <div className={quizStyle.successMessage}>
                          <div className={quizStyle.gradeStyle}>
                            {/* <p>A1</p> */}
                          </div>
                          <p className={quizStyle.description}>
                            {submittedQuizScoreData[0]?.quizId?.title}
                          </p>
                          <h3>Result</h3>
                          <h2>
                            Your Score :{" "}
                            {submittedQuizScoreData[0]?.score || "0"} %
                          </h2>
                          <img src="/successQuiz.png" />
                        </div>
                      ) : (
                        <div>
                          <div className={quizStyle.progressBarContainer}>
                            {quizData?.questions?.map((_, index) => (
                              <div
                                key={index}
                                className={`${quizStyle.progressSegment} ${
                                  startProgress && index < progress
                                    ? quizStyle.active
                                    : ""
                                }`}
                              ></div>
                            ))}
                          </div>
                          <div className={quizStyle.questionSection}>
                            <p className={quizStyle.questionNumber}>
                              {currentQuestion + 1}.
                            </p>
                            <p className={quizStyle.questionText}>
                              {quizData?.questions[currentQuestion]?.question}
                            </p>
                          </div>
                          <div className={quizStyle.answerSection}>
                            {quizData?.questions[currentQuestion]?.options?.map(
                              (option, index) => (
                                <button
                                  key={index}
                                  className={`${quizStyle.answerButton} ${
                                    selectedAnswers[currentQuestion]?.answer ===
                                    option
                                      ? quizStyle.selectedAnswer
                                      : ""
                                  }`}
                                  onClick={() =>
                                    handleAnswerOptionClick(
                                      quizData?.questions[currentQuestion]?._id,
                                      option
                                    )
                                  }
                                >
                                  <div className={quizStyle.optionLabel}>
                                    {String.fromCharCode(65 + index)}
                                  </div>
                                  <div className={quizStyle.optionText}>
                                    {option}
                                  </div>
                                </button>
                              )
                            )}
                          </div>
                          <button
                            className={`${quizStyle.submitAnswerButton} ${
                              isQuizReadyToSubmit
                                ? quizStyle.activeButton
                                : quizStyle.disabledButton
                            }`}
                            onClick={
                              isQuizReadyToSubmit ? handleSubmitQuiz : null
                            }
                            disabled={!isQuizReadyToSubmit}
                          >
                             Submit Quiz
                          </button>

                         
                        </div>
                        
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className={courseVideo.authorName}>Quiz</div>
                  <div className={courseVideo.descriptionText}>
                    No quiz are added yet!
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Quiz;
